import api from '@/api'
import { utils } from '@/utils'
import { isEmpty } from 'lodash'
import moment from 'moment'
import vuex from '@/store'
import dayjs from 'dayjs'
import _ from 'lodash'

const stories = {
  state: {
    list: [],
    monitoredStories: [],
    rundownItems: [],
    archives: [],
    archiveOptions: {},
    myassignments: [],
    mytasks: [],
    mystories: [],
    mypitches: [],
    plannerHeaderStories: [],
    currentAssignment: {},
    currentTask: {},
    currentStory: {},
    isDirty: false,
    linkedStory: {},
    parentStory: {},
    currentModalView: 'story',
    currentAssignmentView: 'details', // or script
    calendarStories: [],
    deletedStories: [],
    lastUpdatedAt: 0
  },
  mutations: {
    LOAD_STORIES(state, list) {
      list.sort((a, b) => b.id - a.id)
      state.list = list
      console.debug(`LOAD_STORIES`, list)
    },
    LOAD_STORY(state, story) {
      const index = state.list.findIndex((s) => s.id == story.id)
      if (index > -1) state.list.splice(index, 1, story)
      else state.list.push(story)
      state.list.sort((a, b) => b.id - a.id)
      console.debug(`LOAD_STORY`, story)
    },
    UNLOAD_STORY(state, storyId) {
      // look in the store for the story to unload
      const index = state.list.findIndex((s) => s.id == storyId)
      // if we found it, remove it from the store
      if (index > -1) state.list.splice(index, 1)
      console.debug(`UNLOAD_STORY`, storyId)
    },
    LOAD_RUNDOWN_ITEMS(state, items) {
      state.rundownItems = items
      console.debug(`LOAD_RUNDOWN_ITEMS`, items)
    },
    LOAD_ARCHIVES(state, list) {
      state.archives = list
      console.debug(`LOAD_ARCHIVES`, list)
    },
    LOAD_MY_TASKS(state, data) {
      state.mytasks = data
      console.debug(`LOAD_MY_TASKS`, data)
    },
    LOAD_MY_ASSIGNMENTS(state, data) {
      state.myassignments = data
      console.debug(`LOAD_MY_ASSIGNMENTS`)
    },
    LOAD_MY_STORIES(state, stories) {
      stories.sort((a, b) => {
        let aDate = a.story_date ? moment(a.story_date).valueOf() : Infinity
        let bDate = b.story_date ? moment(b.story_date).valueOf() : Infinity
        return aDate - bDate
      })
      state.mystories = stories
      console.debug(`LOAD_MY_STORIES`, stories)
    },
    LOAD_MY_PITCHES(state, stories) {
      stories.sort((a, b) => {
        let aDate = a.story_date ? moment(a.story_date).valueOf() : Infinity
        let bDate = b.story_date ? moment(b.story_date).valueOf() : Infinity
        return aDate - bDate
      })
      state.mypitches = stories
      console.debug(`LOAD_MY_PITCHES`)
    },
    LOAD_PLANNER_HEADER_STORIES(state, stories) {
      stories.sort((a, b) => {
        let aDate = a.story_date ? moment(a.story_date).valueOf() : Infinity
        let bDate = b.story_date ? moment(b.story_date).valueOf() : Infinity
        return aDate - bDate
      })
      state.plannerHeaderStories = stories
      console.debug(`LOAD_PLANNER_HEADER_STORIES`)
    },
    LOAD_MONITORED_STORIES(state, stories) {
      stories.sort((a, b) => (a.story_date < b.story_date ? -1 : a.story_date > b.story_date ? 1 : 0))
      state.monitoredStories = stories
      console.debug(`LOAD_MONITORED_STORIES`, stories)
    },
    SET_STORY(state, object) {
      state.currentStory = object
    },
    SET_STORY_DIRTY(state, isDirty) {
      state.isDirty = isDirty
    },
    SET_LINKED_STORY(state, object) {
      state.linkedStory = object
    },
    SET_PARENT_STORY(state, object) {
      state.parentStory = object
    },
    SET_ASSIGNMENT(state, object) {
      state.currentAssignment = object
      console.debug(`SET_ASSIGNMENT`, object)
    },
    SET_TASK(state, object) {
      state.currentTask = object
      console.debug(`SET_TASK`, object)
    },
    SET_MODAL_VIEW(state, view) {
      state.currentModalView = view
    },
    SET_ASSIGNMENT_VIEW(state, view) {
      state.currentAssignmentView = view
    },
    LOAD_CALENDAR_STORIES(state, list) {
      state.calendarStories = list
      console.debug(`LOAD_CALENDAR_STORIES`, list)
    },
    SET_CALENDAR_STORIES(state, list) {
      state.calendarStories = list
      console.debug(`SET_CALENDAR_STORIES`, list)
    },
    LOAD_DELETED_STORIES(state, list) {
      state.deletedStories = list
      console.debug(`LOAD_DELETED_STORIES`, list)
    },
    SET_LAST_UPDATED_AT(state, updated_at_ts) {
      state.lastUpdatedAt = updated_at_ts
    }
  },
  actions: {
    async loadStories({ commit, state, dispatch }, skipCache) {
      // get list of stories from API
      const _s = await api.newsdesk.getStories('scope=active', skipCache)
      const stories = _s?.data ?? []

      // get list of attahments from API
      // const _a = await api.newsdesk.getAttachments('both', skipCache)
      // const attachments = _a?.data ?? []

      // link attachments to stories and label null story_date
      const list = stories.map((story) => {
        // story.attachments = attachments.filter((a) => a.story_id == story.id)
        story.story_date_label = isEmpty(story.story_date) ? 'TBD' : story.story_date
        return story
      })
      commit('LOAD_STORIES', list)

      // We should update the current story object also.
      if (state?.currentStory?.id) {
        let match = list.find((story) => story.id == state.currentStory.id)
        if (match) {
          dispatch('loadStory', { id: match.id, skipCache: true })
        }
      }

      dispatch('getRundowns', true).catch((error) => {
        console.error('Could not get rundowns', error)
      })
      dispatch('loadSubscriptions', true).catch((error) => {
        console.error('Could not get subscriptions', error)
      })
      dispatch('loadMonitoredStories', true).catch((error) => {
        console.error('Could not get monitored stories', error)
      })
      dispatch('loadPresentTasks', true).catch((error) => {
        console.error('Could not get tasks', error)
      })
    },

    async loadMyStories({ commit, state, dispatch }, skipCache) {
      const _s = await api.newsdesk.getMyStories(skipCache)
      const stories = _s?.data ?? []
      commit('LOAD_MY_STORIES', stories)
    },
    async loadMyPitches({ commit, state, dispatch }, skipCache) {
      const _s = await api.newsdesk.getMyPitches(skipCache)
      const stories = _s?.data ?? []
      commit('LOAD_MY_PITCHES', stories)
    },
    async loadPlannerHeaderStories({ commit, state, dispatch }, skipCache = false) {
      const _s = await api.newsdesk.getPlannerHeaderStories(skipCache)
      const stories = _s?.data ?? []
      commit('LOAD_PLANNER_HEADER_STORIES', stories)
    },
    async getChanges({ commit, state, dispatch }) {
      let response = await api.newsdesk.getChanges()
      if (!response) return
      // find story change
      let storyChange = response.data?.find((c) => c.change_type == 'story') ?? {}

      if (state.lastUpdatedAt < storyChange.updated_at_ts) {
        commit('SET_LAST_UPDATED_AT', storyChange.updated_at_ts)
        await dispatch('loadStories', true)
      }
      return
    },

    async loadStory({ commit, state, dispatch }, { skipCache, id, setStory = true, deleted = false, station = vuex.getters.currentStation.station }) {
      const _s = await api.newsdesk.getStoryWithDetails(id, skipCache, deleted, station)
      const story = _s // ?.data?.find(s => s.id == id)
      if (!story) return
      commit('LOAD_STORY', story)
      if (setStory) dispatch('setStory', story)
      return story
    },

    async loadMonitoredStories({ commit, state, dispatch }, { params, skipCache } = {}) {
      // get list of stories from API
      const _s = await api.newsdesk.getMonitoredStories(params, skipCache)
      const stories = _s?.data ?? []

      commit('LOAD_MONITORED_STORIES', stories)
    },

    async getRundowns({ commit, state, dispatch }, skipCache) {
      try {
        const _i = await api.nrcs.getAllNewsdeskItems(skipCache)
        const items = _i?.data?.data ?? []
        commit('LOAD_RUNDOWN_ITEMS', items)
      } catch (error) {
        console.error('Could not get rundowns from NRCS', error)
      }
    },
    async getRundownItems({ commit, state, dispatch }, skipCache) {
      let assignments = state.list.reduce((assignments, story) => [...assignments, ...story.assignments], [])
      let remoteIds = assignments.filter((a) => a.remote_id).map((a) => a.remote_id)
      try {
        const _i = await api.nrcs.getStories(remoteIds, skipCache)
        const items = _i?.data?.data ?? []
        commit('LOAD_RUNDOWN_ITEMS', items)
      } catch (error) {
        console.error('Could not get rundown items from NRCS', error)
      }
    },
    async loadArchives({ commit, state, dispatch }, options) {
      if (options.keywords?.length < 3 && options.start == null) {
        return
      }

      const { skipCache, ...archiveOptions } = options
      state.archiveOptions = archiveOptions

      const response = await api.newsdesk.searchStories(options.keywords, options.start, options.end, 2500, options.skipCache)
      let list = response?.data ?? []
      list = _.uniqBy(list, 'id')
      if (response?.data?.errors?.length > 0) {
        list = []
        console.error(response?.data?.errors)
      }
      commit('LOAD_ARCHIVES', list)

      // We should update the current story object also.
      if (state?.currentStory?.id) {
        let match = list.find((story) => story.id == state.currentStory.id)

        if (match) {
          dispatch('setStory', match)
        }
      }
    },
    async setStory({ commit, state }, story) {
      if (state.currentStory?.id != story?.id) {
        commit('SET_LINKED_STORY', {})
      }

      commit('SET_STORY', story)
    },
    async setStoryDirty({ commit, state }, isDirty) {
      commit('SET_STORY_DIRTY', isDirty)
    },
    async setLinkedStory({ commit }, story) {
      commit('SET_LINKED_STORY', story ?? {})
    },
    async setParentStory({ commit }, story) {
      commit('SET_PARENT_STORY', story)
    },
    async setAssignment({ commit }, assignment) {
      commit('SET_ASSIGNMENT', assignment)
    },
    async setTask({ commit }, task) {
      commit('SET_TASK', task)
    },
    async setModalView({ commit, state }, view) {
      commit('SET_MODAL_VIEW', view)
    },
    async setAssignmentView({ commit, state }, view) {
      commit('SET_ASSIGNMENT_VIEW', view)
    },
    async loadMyTasks({ commit }, skipCache) {
      const response = await api.newsdesk.getMyTasks(skipCache)
      commit('LOAD_MY_TASKS', response?.data ?? [])
    },
    async loadMyAssignments({ commit }, skipCache) {
      const response = await api.newsdesk.getMyAssignments(skipCache)
      commit('LOAD_MY_ASSIGNMENTS', response?.data ?? [])
    },
    async loadCalendarStories({ commit }, options) {
      // commit('LOAD_CALENDAR_STORIES', [])
      const showDate = options?.showDate ?? new Date()
      const startDate = dayjs.tz(options.startDate.toISOString(), vuex.getters.currentTimezone).format('YYYY-MM-DD')
      const endDate = dayjs.tz(options.endDate.toISOString(), vuex.getters.currentTimezone).format('YYYY-MM-DD')

      let stories = []
      let tasks = []

      options.types = options.types ?? {}

      if (options.types.approved || options.types.idea || options.types.scheduling || options.types['info only'] || options.types.bust || options.types.event) {
        try {
          // build filter object
          let filter = {}

          // handle approval types
          let approvalTypes = []
          if (options.types?.approved && options.types?.idea && options.types?.scheduling) {
            // do nothing
          } else {
            if (options.types.approved) approvalTypes.push('Approved')
            if (options.types.idea) approvalTypes.push('Idea')
            if (options.types.scheduling) approvalTypes.push('Scheduling')
            if (options.types['info only']) approvalTypes.push('Info Only')
            if (options.types.bust) approvalTypes.push('Bust')
            filter.story_approved = approvalTypes.join(',')
          }

          // handle story tags
          let tags = options.tags
          if (tags.length) filter.story_tags = tags.join(',')

          // handle story pillars
          if (options.pillars?.length) filter.pillar = options.pillars.join(',')

          let rParams = {
            filter,
            startDate,
            endDate,
            include: '',
            limit: options?.limit ?? 2500
          }
          const response = await api.newsdesk.fetchStories(rParams, options?.skipCache)
          let storiesData = response?.data

          stories = storiesData.map((story) => {
            story.startDate = story.story_date
            story.endDate = story.end_date ?? story.story_date
            story.class = story.story_type.toLowerCase() === 'event' ? 'event' : story.story_approved.toLowerCase()
            return story
          })
        } catch (error) {
          console.error('Failed to get stories for loadCalendarStories', error)
          throw error
        }
      }
      if (options.types?.task) {
        try {
          const tasksResponse = await api.newsdesk.searchTasks(
            {
              start_date: startDate,
              endDate: endDate,
              limit: 2500
            },
            options?.skipCache ?? false
          )
          let tasksData = tasksResponse?.data ?? []
          tasksData = tasksData.filter((t) => t.s_story_approved !== 'Bust')

          tasks = await Promise.all(
            tasksData.map(async (task) => {
              // let taskStory = await (_.head(task.story) ?? api.newsdesk.getStoryWithDetails(task.story_id)) // temp fix for missing story data in task data
              task.startDate = task.start_date
              task.originalTitle = task.title
              task.title = `${task.title}`.toUpperCase() + ` - ${task.story?.title}`
              task.class = 'task'
              // task.story = JSON.parse(JSON.stringify(taskStory))
              return task
            })
          )
        } catch (error) {
          console.error('Failed to get tasks for loadCalendarStories', error)
        }
      }

      commit('LOAD_CALENDAR_STORIES', stories.concat(tasks) ?? [])
    },
    setCalendarStories({ commit, state }, list) {
      commit('SET_CALENDAR_STORIES', list)
    },
    async updateCalendarStory({ commit, state, dispatch }, story_id) {
      if (story_id === null || story_id === undefined) {
        return
      }
      const updatedStory = await api.newsdesk.getStory({ id: story_id })
      const linkedStories = await api.newsdesk.loadLinkedStories(updatedStory.master_id, true)
      let items = state.calendarStories

      _.forEach(linkedStories.data ?? [], (story) => {
        story = Object.assign({}, story, {
          startDate: story.story_date,
          endDate: story.end_date ?? story.story_date,
          class: story.story_type.toLowerCase() === 'event' ? 'event' : story.story_approved?.toLowerCase()
        })

        let indexOfExistingStory = _.findIndex(items, { id: story.id })
        if (indexOfExistingStory !== -1) {
          items.splice(indexOfExistingStory, 1, story)
        } else {
          items.push(story)
        }

        //  update current story, so if a modal is up, the content can be updated
        if (state.currentStory?.id === story?.id) {
          dispatch('setStory', story)
        }

        _.forEach(story.tasks ?? [], (task) => {
          task = Object.assign({}, task, {
            startDate: task.start_date,
            originalTitle: task.title,
            title: `${task.title}`.toUpperCase() + ` - ${story.title}`,
            class: 'task',
            story: JSON.parse(JSON.stringify(story))
          })

          let indexOfExistingTask = _.findIndex(items, { id: task.id, class: 'task' })
          if (indexOfExistingTask !== -1) {
            items.splice(indexOfExistingTask, 1, task)
          } else {
            items.push(task)
          }

          if (state.currentTask?.id === task?.id) {
            dispatch('setTask', task)
          }
        })
      })

      commit('SET_CALENDAR_STORIES', items)
    },
    deleteCalendarStory({ commit, state }, story_id) {
      if (story_id === null) {
        return
      }
      let items = state.calendarStories
      items = _.reject(items, (item) => story_id === item.id)
      commit('SET_CALENDAR_STORIES', items)
    },
    deleteCalendarTask({ commit, state, dispatch }, task) {
      if (task === null) {
        return
      }
      let items = state.calendarStories
      items = _.reject(items, (item) => item.class === 'task' && task.id === item.id)
      commit('SET_CALENDAR_STORIES', items)

      dispatch('updateCalendarStory', task.story_id)
    },
    async updateArchiveStory({ commit, state, dispatch }, story_id) {
      if (story_id === null || story_id === undefined) {
        return
      }
      let story = await api.newsdesk.getStoryWithDetails(story_id)

      story = Object.assign({}, story, {
        story_date_label: story.story_date
      })

      let items = state.archives

      let indexOfExistingStory = _.findIndex(items, { id: story.id })
      if (indexOfExistingStory !== -1) {
        items.splice(indexOfExistingStory, 1, story)
        dispatch('setStory', story)
      } else {
        items.push(story)
      }
      commit('LOAD_ARCHIVES', items)
    },
    async loadDeletedStories({ commit, state, dispatch }) {
      commit('LOAD_DELETED_STORIES', [])

      const _s = await api.newsdesk.getStories('deleted=1', true)
      const stories = _s?.data ?? []
      const list = stories.map((story) => {
        story.story_date_label = isEmpty(story.story_date) ? 'TBD' : story.story_date
        return story
      })

      if (state?.currentStory?.id) {
        let match = list.find((story) => story.id == state.currentStory.id)
        if (match) {
          dispatch('setStory', match)
        }
      }
      commit('LOAD_DELETED_STORIES', list)
    }
  },
  getters: {
    stories(state) {
      return state.list
    },
    monitoredStories(state) {
      return state.monitoredStories
    },
    rundownItems(state) {
      return state.rundownItems
    },
    archives(state) {
      return state.archives
    },
    archiveOptions(state) {
      return state.archiveOptions
    },
    mytasks(state) {
      return state.mytasks
    },
    myassignments(state) {
      return state.myassignments
    },
    mystories(state) {
      return state.mystories
    },
    mypitches(state) {
      return state.mypitches
    },
    plannerHeaderStories(state) {
      return state.plannerHeaderStories
    },
    currentStory(state) {
      return state.currentStory ?? {}
    },
    isDirty(state) {
      return state.isDirty ?? false
    },
    linkedStory(state) {
      return state.linkedStory ?? {}
    },
    parentStory(state) {
      return state.parentStory ?? {}
    },
    currentTask(state) {
      return state.currentTask
    },
    currentAssignment(state) {
      return state.currentAssignment
    },
    currentModalView(state) {
      return state.currentModalView ?? 'story'
    },
    currentAssignmentView(state) {
      return state.currentAssignmentView ?? 'details'
    },
    calendarStories(state) {
      return state.calendarStories
    },
    deletedStories(state) {
      return state.deletedStories
    },
    lastUpdatedAt(state) {
      return state.lastUpdatedAt
    }
  }
}

export default stories
